<div class="mainDiv">
    
    <div *ngIf="firstPage">
        <!-- <div><span class="needhelp" style="float:right;">
                <a  (click)="hotlineSubmit()">{{'Need help with:Identify Failure'|translate}}?</a></span>
        </div> -->
        <form name="identifyFailureForm" method="post"><input type="hidden"><input type="hidden"
                value="{{'true'|translate}}">
            <p>{{'Identify Failure text1'|translate}}.</p>
            <br>
            <p>{{'Identify Failure text2'|translate}}.</p>
            <div class="doNotFloat">
                <table class="mainTable" style="border:0; width:95%;margin-left: -36%;" cellspacing="0" cellpadding="3">
                    <tbody>

                        <tr>
                            <td style="vertical-align:top; text-align:right; width:50%" class="prompt">
                                {{'VIN'|translate}}:</td>
                            <td style="text-align:left; width:50%">
                                <input type="text" name="vin" maxlength="17" size="30" readonly="readonly"
                                    value={{vinNumber}}>
                            </td>
                        </tr>

                        <tr>
                            <td style="vertical-align:top; text-align:right; width:50%" class="prompt">
                                {{'Group'|translate}}:</td>
                            <td style="text-align:left; width:50%">
                                <select name="groupName" [(ngModel)]="groupName" #setGroupname
                                    (change)="onSelectgroup(setGroupname.value,1)" style="position: relative;">
                                    <option value="default">{{'Select'|translate}}</option>
                                    <option *ngFor="let g of groupSearch" [value]="g">{{g}}</option>
                                </select>
                            </td>
                        </tr>

                        <tr>
                            <td style="vertical-align:top; text-align:right; width:50%" class="prompt">
                                {{'Section'|translate}}:</td>
                            <td style="text-align:left; width:50%">
                                <select *ngIf="!secheck" name="sectionName1" [(ngModel)]="sectionName"
                                    [disabled]="disabledSection" (change)="onSelectSection(sectionName)"
                                    style="position: relative;min-width:125px; width: auto;">
                                    <option value="default">{{'Select'|translate}}</option>
                                    <option *ngFor="let s of sectionArray" [value]="s">{{s}}</option>
                                    <option *ngIf="flagsection" [selected]="flagsection" value="flagsection">{{'Other
                                        not on list'|translate}}</option>
                                </select>
                                <select *ngIf="secheck" name="sectionName2" [(ngModel)]="sectionName"
                                    (change)="onSelectSection(sectionName)"
                                    style="position: relative;min-width:125px; width: auto;">
                                    <option value="default">{{'Select'|translate}}</option>
                                    <option *ngIf="flagsection" [selected]="flagsection" value="flagsection">{{'Other
                                        not on list'|translate}}</option>
                                </select>
                                &nbsp;
                                <img *ngIf="!changeSectionList" alt="-" title="Turn off qualifier filter"
                                    (click)="onSelectgroup(setGroupname.value,2);changeSectionList=!changeSectionList"
                                    style="vertical-align: middle;" src="/assets/images/nav.gif" width="18" height="18">
                                <img *ngIf="changeSectionList" alt="+" title="Turn on qualifier filter"
                                    (click)="onSelectgroup(setGroupname.value,3);changeSectionList=!changeSectionList"
                                    style="vertical-align: middle;" src="/assets/images/NavOn.gif" width="18"
                                    height="18"><span> - {{'If you cannot see the required section, turn off the
                                    qualification filter and try again'|translate}}.</span>
                            </td>
                        </tr>

                        <tr>
                            <td style="vertical-align:top; text-align:right; width:50%" class="prompt">
                                {{'Component'|translate}}:</td>
                            <td style="text-align:left; width:50%">
                                <select *ngIf="!cocheck" [disabled]="disabledcomponent" name="componentName"
                                    [(ngModel)]="componentName" #setCompname
                                    (change)="onSelectComponent(setCompname.value)"
                                    style="position: relative;min-width:125px; width: auto;">
                                    <option value="default">{{'Select'|translate}}</option>
                                    <option *ngFor="let c of componentSearch" [value]="c">{{c}}</option>
                                    <option *ngIf="flagsection" [selected]="flagsection" value="flagsection">{{'Other
                                        not on list'|translate}}</option>
                                </select>
                                <select *ngIf="cocheck" [disabled]="disabledcomponent" name="componentName"
                                    [(ngModel)]="componentName" #setCompname
                                    (change)="onSelectComponent(setCompname.value)"
                                    style="position: relative;min-width:125px; width: auto;">
                                    <option value="default">{{'Select'|translate}}</option>
                                    <option *ngIf="flagsection" [selected]="flagsection" value="flagsection">{{'Other
                                        not on list'|translate}}</option>
                                </select>
                            </td>
                        </tr>

                        <tr>
                            <td style="vertical-align:top; text-align:right; width:50%" class="prompt">{{'Component
                                Search'|translate}}:
                            </td>
                            <td style="text-align:left; width:140%">
                                <input list="autocompleteList" autocomplete="on" type="text" class="searchText"
                                    name="allComponentName" [(ngModel)]="allComponentName" (keyup)="updateList()" [disabled]="isComponentSearchDisabled"/><br>
                            </td>
                        </tr>
                        <tr *ngIf="showSuggest">
                            <td style="vertical-align:top; text-align:right; width:50%"></td>
                            <td style="text-align:left; width:50%">
                                <select style="width:140%;" size="5" multiple="true" name="allComponentHidden"
                                    #setAllCompname (change)="onSelectAllComponent(setAllCompname.value)"
                                    [(ngModel)]="allComponentHidden">
                                    <option *ngFor="let d of allComponentSearch">{{d}}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                    </tbody>
                </table>

                <p>{{'Identify Failure text3'|translate}}</p>
                <p>{{'Identify Failure text4'|translate}}</p>
            </div>
            <p>
                <input type="submit" value="{{'Select'|translate}}" (click)="onselect()"
                    [disabled]="disabledselectbutton" id="button">
            </p>
          <ng-template #data let-modal>
              <div class="container version">
               <div class="row popup-header" style="margin-top: 0%;">
                   <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                                                                        (click)="modal.dismiss('Cross click')"></i></div>
               </div>
               <div class="modal-body">
                <p>To Request an RVC for this component, please contact technical assistance.</p>
               </div>
                  <hr class="hr-line1">
               <div class="popup-footer">
                  <button type="button" class="close-btn-popup pull-right" name=continue
                          (click)="continueRequest(data)">{{'Contact MVT'|translate}}</button>
               </div>
              </div>
          </ng-template>
        </form>
    </div>
    <div *ngIf="!firstPage">
      <div *ngIf="showRvcInput">
        <div class="rvc">
          <h2>Enter the Valid RVC code</h2>
          <div>
            <input type="text" [(ngModel)]="rvcCode" placeholder="Enter RVC code">
            <button (click)="validateRvcCode()">Validate</button>
          </div>
          <div *ngIf="validationError">{{ validationError }}</div><br>
          <div class="button-group">
            <button class= "buttons" (click)="pauseSession()">Pause/Leave Session</button>
            <button class= "buttons" style="margin-left: 10px" (click)="endSession()">End Session</button>
          </div>
        </div>

        <ng-template #InvalidRvcTemplate let-modal>
          <div class="container version">
            <div class="row popup-header" style="margin-top: 0%;">
              <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                                                                    (click)="modal.dismiss('Cross click')"></i></div>
            </div>
            <div class="modal-body">
              <p style="font-size: 10pt;">The entered RVC Code is Invalid</p>
            </div>
            <div class="popup-footer">
              <button type="button" class="close-btn-popup pull-right" name=close (click)="modal.dismiss('Cross click')">{{'Close'|translate}}</button>
            </div>
          </div>
        </ng-template>
      </div>
        <div *ngIf="!onList && !showRvcInput">
            <p>{{'Identify Failure text5'|translate}}</p>
            <p>{{'Identify Failure text6'|translate}}</p>
            <form>
                <input type="hidden">
                <p class="prompt">{{'Faulty Component/Repair'|translate}}:</p>
                {{edit}}
                <button class="rateControlled" [hidden]="isDSSHRestrictedModule" (click)="onEdit()">{{'Edit'|translate}}</button>
                <br>
                <br>
                <p>
                    <span class="prompt">{{'Identify Failure text7'|translate}}</span><br>

                    <textarea name="causeRepair" (keyup)="checkLength()" [(ngModel)]="causeRepair"
                        name="failureComments" cols="65" rows="3" id="failureComments"></textarea>
                    <br>
                    <span *ngIf="!colorflag" style="white-space:nowrap;">
                        {{'Characters Remaining'|translate}}:
                        <span id="counter">{{count}}</span>
                    </span>
                    <span *ngIf="colorflag" style="white-space:nowrap; color:red">
                        {{'Characters Remaining'|translate}}:
                        <span id="counter">{{count}}</span>
                    </span>

                    <br>
                    <span class="prompt">{{'Do not enter any personally identifiable information'|translate}}</span>
                    <br>
                </p>
                <div *ngIf="errorMessage" style="color:red">{{errorMessage}}</div>
                <div *ngIf="errorMsg" style="color:red">{{errorMsg}}.</div>
                <input type="submit" (click)="confirm()" value="{{'Confirm'|translate}}" class="rateControlled">
            </form>

            <p>{{'Identify Failure text8'|translate}}</p>
            <div class="needhelp1">
                <p><a (click)="gcrSubmit()">Global Concern Reporting (GCR)</a></p>
            </div>
            <p>{{'Identify Failure text9'|translate}}
                <!-- <a href="#" onclick="myNewWindow()">help</a>. -->
            </p>
        </div>

        <div *ngIf="onList && !showRvcInput">
            <div *ngIf="secondPage">
                <p>{{'Identify Failure text10'|translate}}
                </p>
                <p>{{'Identify Failure text11'|translate}}</p>
                <form>
                    <input type="hidden">
                    <p class="prompt">{{'Faulty Component/Repair'|translate}}:</p>
                    {{edit}}
                    <button class="rateControlled" [hidden]="isDSSHRestrictedModule" (click)="onEdit()">{{'Edit'|translate}}</button>
                    <br>
                    <br>
                    <div>
                        <p>
                            <span class="prompt">{{'FINIS Code'|translate}}: &nbsp;</span>
                            <input name="finis" [(ngModel)]="finis" [disabled]="disableCheckFinis" type="text"
                                (ngModelChange)="onFinis()" maxlength="7" size="7" value="">
                            <span
                                style="color: red; font-weight: 600;">({{'FINIS_RVC_Text_Explanation'|translate}})</span>
                        </p>
                    </div>
                    <p>
                        <span class="prompt">{{'Labor only'|translate}}: &nbsp;</span>
                        <input (change)="laborCheck()" name="labor" style="position:unset" [(ngModel)]="isChecked"
                            type="checkbox" [disabled]="disableLabor">
                    </p>
                    <p>
                        <span class="prompt">{{'Identify Failure text12'|translate}}:</span><br>
                        <textarea name="causeRepair" (keyup)="checkLength()" [(ngModel)]="causeRepair"
                            name="failureComments" cols="65" rows="3" id="failureComments"></textarea>
                        <br>
                        <span *ngIf="!colorflag" style="white-space:nowrap;">
                            {{'Characters Remaining'|translate}}:
                            <span id="counter">{{count}}</span>
                        </span>
                        <span *ngIf="colorflag" style="white-space:nowrap; color:red">
                            {{'Characters Remaining'|translate}}:
                            <span id="counter">{{count}}</span>
                        </span>
                        <br>
                        <span class="prompt">{{'Do not enter any personally identifiable information'|translate}}</span>
                        <br>
                    </p>
                    <div *ngIf="errorMessage" style="color:red">{{errorMessage}}</div>
                    <div *ngIf="errorMsg" style="color:red">{{errorMsg}}.</div>
                    <div *ngIf="lengthofcommenterror" style="color:red">{{lengthofcommenterror}}</div>
                    <input type="submit" [ngStyle]="{'color': isConfirBtnVisuallyDisabled ? 'gray' : 'black'}"
                        (click)="confirm()" value="{{'Confirm'|translate}}" class="rateControlled">
                </form>
                <p>{{'Identify Failure text8'|translate}}</p>
                <div class="needhelp1">
                    <p><a (click)="gcrSubmit()">Global Concern Reporting (GCR)</a></p>
                </div>
                <p>{{'Identify Failure text9'|translate}}
                    <!-- <a href="#" onclick="myNewWindow()">{{'help'|translate}}</a>. -->
                </p>

            </div>
        </div>
        <div *ngIf="!secondPage && !showRvcInput">
        <div class="d-flex justify-content-end align-items-center mb-3" style="width: 95%; margin-top: 5px;">

    <i class="fa fa-file-pdf-o me-3" 
       (click)="downloadPageAsPdf()" 
       title="Download PDF"
       style="cursor: pointer; font-size: 1.3rem; color: #d32f2f;">
    </i>
    <i class="fa fa-print" 
       (click)="printPageNative()" 
       title="Print Page"
       style="cursor: pointer; font-size: 1.3rem; color: #003399;">
    </i>
  </div>
            <div class="container">
                <div class="left-content">
                    <div class="mainDivi">
                        <!-- <div>
                            <span class="needhelp">
                                <a (click)="hotlineSubmit()">{{'Need help with'|translate}}:&nbsp;
                                    {{'Component/Repair Type Identified'|translate}} ? </a>
                            </span>
                        </div> -->
                        <p><span class="prompt">{{'Faulty Component/Repair'|translate}}:</span>
                            {{'Other not on list'|translate}}</p>
                        <p><span class="prompt">{{'Repair Validation Code'|translate}}:</span><span
                                class="whatsnewheader" style="padding: 4px">{{'No RVC Required'|
                                translate}}</span>&nbsp;&nbsp;
                        </p>
                        <p style="color: red; font-weight: 600;">({{'FINIS_RVC_Not_Generation'|translate}})</p>
                        <p>{{'Return to the start of diagnostic'|translate}}.</p>
                        <input type="submit" value="{{'session_complete'|translate}}" (click)="restartDiagnostics()">
                    </div>
                </div>
                <div class="right-notes">
                    <h4>{{'RVC_Header'|translate}}</h4>
                    <p> 1. {{'NoRVC_Msg'|translate}}.<br>

                        2. {{'RVCMsg_Contact_Helpdesk'|translate}}.

                    </p>
                </div>
            </div>
            
        </div>
    </div>
</div>
<ng-template #faultMsgInfo let-modal>
    <div class="container version">
        <div class="row popup-header" style="margin-top: 0%;">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('faultMsgInfo')"></i></div>
        </div>
        <div>
            <label class='msg-body'>
                <p>
                    {{'Claim_Info'|translate}}: -<br>
                    1. {{'MainGroup_Info'|translate}}.<br>
                    2. {{'Labour_Info'|translate}}.<br>
                    3. {{'FinisCode_Info'|translate}}.
                </p>
            </label>
        </div>
        <hr class="hr-line1">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="modal.dismiss('faultMsgInfo')">{{'continue'|translate}}</button>
        </div>
    </div>
</ng-template>

<ng-template #noRVCMsgInfo let-modal>
    <div class="container version">
        <div class="row popup-header" style="margin-top: 0%;">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    *ngIf="!isButtonEnabled" (click)="modal.dismiss('noRVCMsgInfo')"></i></div>
        </div>
        <div>
            <label class='msg-body'>
                <p class="norvg-msg">{{'norvc_req_description_msg' | translate}}</p>
            </label>
        </div>
        <hr class="hr-line1">
        <div class="popup-footer">
            <button type="button" class="btn btn-primary mr-3 pull-right confirm" name="confirm"
                [disabled]="isButtonEnabled" (click)="modal.dismiss('noRVCMsgInfo')">{{'Confirm'|translate}}</button>
        </div>
    </div>
</ng-template>

<div *ngIf="showSpinner" class="spinner-container">
    <ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" color="#003478" size="medium"
        type="ball-spin-clockwise">
        <p style="font-size: 20px; color: black; margin-top: 50%;"></p>
    </ngx-spinner>
</div>
